<template>
  <v-navigation-drawer
    v-model="toggleDrawer"
    :mini-variant="toggleMini"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :absolute="$vuetify.breakpoint.smAndDown"
    :temporary="$vuetify.breakpoint.smAndDown"
    :mini-variant-width="60"
    dark
    id="left-navbar"
    class="vertical-stretch background-nav"
  >
    <v-divider></v-divider>

    <v-list dense class="pa-0">
      <v-list-item
        v-for="item in menuItems"
        :key="item.title"
        link
        :to="item.path"
        v-track="item.title"
      >
        <v-list-item-icon class="my-4 mr-0">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content class="text-uppercase pl-3">
          <v-list-item-title class="font-weight-bold body-2">
            <span class="secondary--font"
              >{{ item.title }}
            </span></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <v-list dense class="pa-0">
        <v-list-item link :href="helpCenter.path" target="_blank"
         v-track="'help-center-link'">
          <v-list-item-icon class="my-4 mr-0">
            <v-icon>{{ helpCenter.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-capitalize pl-3">
            <v-list-item-title class="font-weight-bold body-2">
              <span class="secondary--font"
                >{{ helpCenter.title }}
              </span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "LeftNavDrawer",
  data() {
    return {
      navList: [
        {
          title: "Dashboard",
          icon: "mdi-home",
          path: "/dashboard",
          show: true,
        },
        { title: "Tickets",
          icon: "mdi-cards",
          path: "/tickets",
          show: true 
        },
        {
          title: "Contacts",
          icon: "mdi-contacts",
          path: "/contacts",
          show: true,
        },
       
        // {
        //   title: "Reports",
        //   icon: "mdi-chart-box",
        //   path: "/reports",
        //   show: true,
        // },
        // { title: "Settings", icon: "mdi-cog", path: "/settings", show: true },
      ],
      helpCenter: {
        title: "help center",
        icon: "contact_support",
        path: "https://galaxy.maropost.com/s/service-articles",
        show: true,
      },
    };
  },
  computed: {
    toggleMini() {
      return this.$vuetify.breakpoint.smAndDown
        ? false
        : this.$store.getters["ui/leftmenu"];
    },
    toggleDrawer: {
      get() {
        return this.$store.getters["ui/leftmenu"];
      },
      set(value) {
        if (value == false) {
          this.$store.dispatch("ui/leftmenu", [
            !this.$store.getters["ui/leftmenu"],
          ]);
        }
      },
    },
      menuItems() {
      let accountId = this.$store.getters["auth/account"].id;
      if(accountId){
        var completePath = this.navList.map((item) => {
          if (item.path) {
            item.path = item.path.replace(/\/\d+\/?/,"/");
            item.path = "/" + accountId + item.path;
            return item;
          }
        });
      }
      return completePath;
    },
  },
};
</script>

<style lang="scss" scoped>
#left-navbar {
  .v-icon,
  .v-list-item {
    color: #aaacb1 !important;
  }
  .v-list-item {
    min-height: 59px !important;
  }
  .v-list-item--active {
    -webkit-box-shadow: 5px 0 0 #03b6fc inset;
    box-shadow: inset 5px 0 0 #03b6fc;
    color: #fff !important;
    .v-icon,
    .v-list-item__title {
      color: #fff !important;
    }
  }
}
</style>
